import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb15"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiple_file_upload = _resolveComponent("multiple-file-upload")!
  const _component_biz_file_table = _resolveComponent("biz-file-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _directive_perm = _resolveDirective("perm")!

  return (_openBlock(), _createBlock(_component_a_card, null, {
    default: _withCtx(() => [
      (_ctx.allowEdit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _withDirectives(_createVNode(_component_multiple_file_upload, {
              value: _ctx.fileList,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileList) = $event)),
              "uploaded-count": _ctx.uploadedFileList.length,
              onOk: _ctx.onOk
            }, null, 8, ["value", "uploaded-count", "onOk"]), [
              [_directive_perm, _ctx.uploadAccess]
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_biz_file_table, {
        ref: "bizFileTable",
        "allow-edit": _ctx.allowEdit,
        "biz-id": _ctx.bizId,
        "biz-type": _ctx.bizType,
        "download-access": _ctx.downloadAccess,
        "delete-access": _ctx.deleteAccess
      }, null, 8, ["allow-edit", "biz-id", "biz-type", "download-access", "delete-access"])
    ]),
    _: 1
  }))
}